import { HelpLink } from "@atoms/HelpLink";
import { LogoDataStone } from "@/components/atoms/LogoDataStone";

export const Header = () => {
  const HeaderElement = document.createElement("nav");
  HeaderElement.className =
    "mx-auto w-full max-w-[calc(100%_-_2rem)] flex items-center justify-between md:w-[90%] md:max-w-194 xl:max-w-304";

  HeaderElement.appendChild(LogoDataStone("w-37.5 md:w-max"));
  HeaderElement.appendChild(HelpLink());

  return HeaderElement;
};
